var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7083 0.375H7.29167C3.4875 0.375 0.375 3.4875 0.375 7.29167V55.7083C0.375 59.5125 3.4875 62.625 7.29167 62.625H55.7083C59.5125 62.625 62.625 59.5125 62.625 55.7083V7.29167C62.625 3.4875 59.5125 0.375 55.7083 0.375ZM55.7083 55.7083H7.29167V39.8692L10.7154 43.2929L24.5487 29.4596L38.3821 43.2929L52.2154 29.4942L55.7083 32.9871V55.7083ZM55.7083 23.1654L52.2154 19.6725L38.3821 33.5404L24.5487 19.7071L10.7154 33.5404L7.29167 30.0821V7.29167H55.7083V23.1654Z",
    fill: "#E12A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error-image.c2df2361ca35e8a9d637c82403cccd36.svg";
export { ForwardRef as ReactComponent };